var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.455 1.532c0-.17.137-.307.306-.307h7.966c.169 0 .306.138.306.307v2.604c0 .085.069.153.153.153h.92a.153.153 0 0 0 .153-.153v-2.91C13.259.548 12.71 0 12.033 0H3.455c-.677 0-1.226.549-1.226 1.225v1.073c0 .084.069.153.153.153h.92a.153.153 0 0 0 .153-.154v-.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.077 5.705a.92.92 0 0 0-.9-1.11h-7.73a.306.306 0 0 1-.3-.245l-.17-.857a.92.92 0 0 0-.902-.736H1.31a.92.92 0 0 0-.906 1.074l1.3 7.66a.92.92 0 0 0 .906.764h10.342a.922.922 0 0 0 .9-.73c.326-1.56.86-4.091 1.225-5.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d1a1fbb74624dccf2b8a6fee535ef3f8.svg";
export { ForwardRef as ReactComponent };